export default "__VITE_ASSET__DSLLJNCp__"